/**
 * Build-time configuration. None of it is secret.
 *
 * A SPA client id is PUBLIC by design — PKCE exists so a browser app needs no secret.
 * The tenant, audience and broker host are all public endpoints too. What keeps this
 * app safe is that the token it receives carries an ACL claim the broker enforces; the
 * browser is never trusted with anything.
 */

import { ALL_TOPICS } from "./contract/fleetComms";
export const cfg = {
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN ?? "dev-kdscaosoqvco04gl.us.auth0.com",
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? "ZZs7TtGhZ8hTDFb6eJf9iaQ94kAGXTnz",

  /**
   * MUST be set, and MUST match the Auth0 API Identifier.
   *
   * Without an `audience`, Auth0 issues an OPAQUE access token — a random string, not a
   * JWT. It looks like a perfectly good token right up until the broker tries to parse
   * it and refuses the connection, and nothing in the browser hints at why. This single
   * value is the difference between "logged in and connected" and "logged in and
   * mysteriously rejected".
   */
  audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? "https://mqtt.norbot.ca",

  /**
   * EMQX serves MQTT-over-WebSocket at `/mqtt`. The bare host 404s — verified against
   * the running broker, and a wrong path here produces a connection failure that reads
   * like a network or certificate problem rather than a URL typo.
   */
  brokerUrl: import.meta.env.VITE_BROKER_WSS ?? "wss://mqtt.norbot.ca/mqtt",

  /** Everything the token grants. The BROKER decides what actually arrives. */
  topic: ALL_TOPICS,

  /**
   * The Keenon mock's control plane, for the debug panel. BOTH must be set at build time
   * or the panel does not render at all — a plain production build ships no debug
   * surface, which is why these default to empty rather than to the deployed values.
   *
   *   fly deploy cloud/fleet-web --build-arg VITE_MOCK_URL=https://norbot-keenon-mock.fly.dev \
   *                              --build-arg VITE_MOCK_KEY="$(op read op://…/KEENON_MOCK_KEY)"
   *
   * VITE_MOCK_KEY IS NOT A SECRET once built: this bundle is static and public, so the
   * key is readable by anyone with devtools. It gates casual access to a harness whose
   * whole power is pausing a fabricated robot in the `norbot-test` site. The isolation
   * from production is structural — a separate adapter deployment — not this string.
   */
  mockUrl: import.meta.env.VITE_MOCK_URL ?? "",
  mockKey: import.meta.env.VITE_MOCK_KEY ?? "",
} as const;
